/* eslint-disable no-nested-ternary */
import { Focusable, Tooltip, TooltipTrigger } from '@launchpad-ui/components';
import { Icon } from '@launchpad-ui/icons';

import type { ClauseValidation } from '#utils/validation/clauses';
import type { TargetingRuleValidation } from '#utils/validation/flags';
import type {
  FallthroughValidation,
  PrerequisiteValidation,
  RolloutValidation,
  WeightedVariationValidation,
} from '#utils/validation/targeting';

type TargetingValidationHintProps = {
  validation:
    | ClauseValidation
    | WeightedVariationValidation
    | RolloutValidation
    | FallthroughValidation
    | PrerequisiteValidation
    | TargetingRuleValidation;
};

const TargetingValidationHint = ({ validation }: TargetingValidationHintProps) => (
  <TooltipTrigger>
    <Focusable>
      <span role="button">
        {validation.isIncomplete() ? (
          <Icon name="warning" size="medium" className="u-warning" />
        ) : (
          <Icon name="minus-circle" size="small" className="u-v-top" />
        )}
      </span>
    </Focusable>
    <Tooltip placement="top">{validation.getMessage()}</Tooltip>
  </TooltipTrigger>
);

/* eslint-disable import/no-default-export */
export default TargetingValidationHint;
